import React, { Component } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import {Text} from "@chakra-ui/react";

/*
const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";
*/

const divStyle = {
    width: "95%",

    height: '100%'
    //border: '5px solid black'
};

const columnDefs = [
    { headerName: "Code", field: "code", sortable: true, filter: true, resizable: true, width: 100},
    { headerName: "Message", field: "message", sortable: true, filter: true, resizable: true, width: 450, autoHeight: true, cellStyle: { whiteSpace: 'normal', wordWrap: 'break-word' }    },  
    { headerName: "Transaction Id", field: "transactionId", sortable: true, filter: true, resizable: true, width: 400},
    //{ headerName: "TransT", field: "transT", sortable: true, filter: true, resizable: true, minWidth: 100},
];

export default class DetailErrorTable extends Component {
    constructor(props) {
        super(props);
    }









    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit(params)
    };

    render() {

        return (
            <div className="ag-theme-balham" style={divStyle}>
                {(this.props.errorTableData) &&
                <AgGridReact
                    rowSelection="single"
                    enableRangeSelection={false}
                    // pagination={true}
                    columnDefs={columnDefs}
                    rowData={this.props.errorTableData }
                    animateRows={true}
                    onGridReady={this.onGridReady}
                    //onSelectionChanged={this.onSelectionChanged}
                    gridOptions={this.gridOptions}
                    domLayout="autoHeight"
                    suppressHorizontalScroll={true}
                />
                }
            </div>
        );
    }
}